import React, { Component } from 'react';

//componentes
import Correos from './correos'

class Index extends Component {

    render(){
        return(
            <div>
                <Correos />
            </div>
        );
    }
}
export default Index;